import React, { Fragment } from 'react';
import Media from 'react-media';
import { ActionButton } from '../buttons';
import { InnerWrapper, OuterWrapper, SearchResetOverlay } from './style';
import FilterWidgets from './filterWidgets';
import { ResponsiveFilterPortal } from '../portals';
import { ResponsiveTopBar } from './responsiveFilter';
import { ConnectedStateResults } from '../algoliawrapper';

const Filter = ({ toggleFilter, onFilterReset, searchState, ...props }) => (
  <Fragment>
    <ResponsiveTopBar
      toggleFilter={toggleFilter}
      searchPlaceholder="Artikelnummer"
    />
    <OuterWrapper id="outer">
      <SearchResetOverlay>
        <ActionButton onClick={onFilterReset}>Suche zurücksetzen</ActionButton>
      </SearchResetOverlay>
      <ConnectedStateResults>
        {({ hasHits }) => (
          <Media query="(max-width: 52em)">
            {matches =>
              matches ? (
                <ResponsiveFilterPortal
                  onFilterReset={onFilterReset}
                  toggleFilter={toggleFilter}
                >
                  <FilterWidgets searchState={searchState} hasHits={hasHits} />
                </ResponsiveFilterPortal>
              ) : (
                <InnerWrapper id="inner" {...props}>
                  <FilterWidgets searchState={searchState} hasHits={hasHits} />
                </InnerWrapper>
              )
            }
          </Media>
        )}
      </ConnectedStateResults>
    </OuterWrapper>
  </Fragment>
);

export default Filter;



// WEBPACK FOOTER //
// ../shop_main/components/filter/index.js